"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var translations_context_1 = require("./translations.context");
exports.getTranslation = function (_a) {
    var key = _a.key, fallback = _a.fallback, labels = _a.labels;
    if (!labels)
        return key;
    if (!labels[key] && fallback) {
        console.log("\"" + key + "\": \"" + fallback + "\"");
    }
    if (!labels[key])
        return key;
    return labels[key];
};
var Translations = function (_a) {
    var children = _a.children, appLabels = _a.labels;
    var _b = react_1.useState('en'), currentLanguage = _b[0], setCurrentLanguage = _b[1];
    var context = react_1.useMemo(function () {
        var labels = appLabels[currentLanguage];
        return {
            getTranslation: function (key, fallback) {
                return exports.getTranslation({ key: key, fallback: fallback, labels: labels });
            },
            currentLanguage: currentLanguage,
            setCurrentLanguage: setCurrentLanguage,
            formatDuration: function (seconds, options) {
                if (options === void 0) { options = { hoursOnly: false }; }
                var inMinutes = Math.floor((seconds || 0) / 60);
                var hours = Math.floor(inMinutes / 60);
                var minutes = inMinutes % 60;
                var formattedHours = "" + hours + exports.getTranslation({ key: 'DURATIONS:SHORT_HOURS', labels: labels });
                if (options.hoursOnly) {
                    return formattedHours;
                }
                var formattedMinutes = "" + minutes + exports.getTranslation({
                    key: 'DURATIONS:SHORT_MINUTES',
                    labels: labels,
                });
                if (hours === 0) {
                    return formattedMinutes;
                }
                return formattedHours + " " + formattedMinutes;
            },
        };
    }, [currentLanguage, appLabels, setCurrentLanguage]);
    return react_1.default.createElement(translations_context_1.TranslationProvider, { value: context }, children);
};
exports.default = Translations;
//# sourceMappingURL=translations-container.component.js.map